import { __assign, __extends } from "tslib";
import * as Util from '@antv/util';
import Element from './base';
import PolygonShapeFactory from './shape/polygon';
/**
 * Polygon 多边形
 */
var Polygon = /** @class */ (function (_super) {
    __extends(Polygon, _super);
    function Polygon(cfg) {
        var _this = _super.call(this, __assign({ type: 'polygon', shapeType: 'polygon', generatePoints: true, shareTooltip: false }, cfg)) || this;
        _this.set('shapeFactory', PolygonShapeFactory);
        return _this;
    }
    Polygon.prototype.createShapePointsCfg = function (obj) {
        var cfg = _super.prototype.createShapePointsCfg.call(this, obj);
        var x = cfg.x;
        var y = cfg.y;
        var temp;
        if (!(Util.isArray(x) && Util.isArray(y))) {
            // x y 都是数组时，不做处理
            var xScale = this.getXScale();
            var yScale = this.getYScale();
            // scale 中保证了 values 都会有，所以去掉之前的逻辑判断
            var xCount = xScale.values.length;
            var yCount = yScale.values.length;
            var xOffset = (0.5 * 1) / xCount;
            var yOffset = (0.5 * 1) / yCount;
            if (xScale.isCategory && yScale.isCategory) {
                // 如果x,y都是分类
                // @ts-ignore
                x = [x - xOffset, x - xOffset, x + xOffset, x + xOffset];
                y = [y - yOffset, y + yOffset, y + yOffset, y - yOffset];
            }
            else if (Util.isArray(x)) {
                // x 是数组
                temp = x;
                x = [temp[0], temp[0], temp[1], temp[1]];
                y = [y - yOffset / 2, y + yOffset / 2, y + yOffset / 2, y - yOffset / 2];
            }
            else if (Util.isArray(y)) {
                // y 是数组
                temp = y;
                y = [temp[0], temp[1], temp[1], temp[0]];
                // @ts-ignore
                x = [x - xOffset / 2, x - xOffset / 2, x + xOffset / 2, x + xOffset / 2];
            }
            cfg.x = x;
            cfg.y = y;
        }
        return cfg;
    };
    return Polygon;
}(Element));
export default Polygon;
//# sourceMappingURL=polygon.js.map